import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  filterContainer: {
    backgroundColor: theme.palette.gray30.main,
    borderRadius: "8px",
    padding: "16px",
    maxWidth: "390px",
    fontSize: "10px",
  },
  openFilterContainer: {
    backgroundColor: theme.palette.gray30.main,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    padding: "16px",
    maxWidth: "390px",
  },
}));

export default useStyles;
